<!--
================================================
Un composant pour gérer les formulaires des régalages utilisateur

* Effectue la requête initiale de récupération de l'utilisateur
* Inclut les différents composants contenant les formulaires d'édition.

url : (http://localhost:8080/fr/cronocloud-inc/user/settings)
================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <div id="userSettingsComp" v-bind:class="{'darkMode':themeToDisplay=='dark'}">

        <div class="userSettingFormsCont" >
          <user-setting-infos></user-setting-infos>
            <user-setting-email></user-setting-email>
            <user-setting-password></user-setting-password>
          <user-setting-theme-comp></user-setting-theme-comp>


        </div>
    </div>
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    // @ is an alias to /src
    import UserSettingInfos from '@/components/UserSettingInfosComp.vue'
    import UserSettingEmail from '@/components/UserSettingEmailComp.vue'
    import UserSettingPassword from '@/components/UserSettingPasswordComp.vue'
    import SentryMixin from "../mixins/SentryMixin.js";
    import GlobalErrorNotification from "../mixins/GlobalErrorNotificationMixin.js";
    import UserSettingUIThemeComp from "@/components/UserSettingThemeComp";
    import UserSettingThemeComp from "@/components/UserSettingThemeComp";
    //
    export default {
        name: 'UserSettingsComp',
        mixins: [GlobalErrorNotification, SentryMixin],
        components: {
          UserSettingThemeComp,
          UserSettingUIThemeComp,
            UserSettingInfos,
            UserSettingEmail,
            UserSettingPassword,

        },
        data: function () {
            return {
            }
        },
        computed: {

            // computed props for store :
            ...mapState({
                userSlug: state => state.user.slug,
                themeToDisplay: state =>state.app.themeToDisplay
            })
        },

        methods: {

        },

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
        mounted: function () {
        }
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!--<style scoped lang="scss">-->
<style lang="scss">
    @import "../assets/css/globalVar.scss";
    @import "~bulma/sass/utilities/initial-variables";
    @import "~bulma/sass/utilities/derived-variables";
    @import "~bulma/sass/utilities/mixins";

    #userSettingsComp{

       .formSection {
        margin-bottom: 2rem;
        border-radius: 3px;
        border-width: 1px;
        border-color: #ccc;
        border-style: solid;
        background: #f9f9f9;

        .help{

            color: $grey-light;
            font-size: 0.9rem;
            font-style: italic;

            &.is-danger{
                color: $danger
            }
            &.is-warning{
                color: #f8b81f
            }
        }

        .spacer {
            padding: 2rem;
        }
        .contTitle{
            h3{
                //text-align: left;
                color:#666;
                font-size: 1rem;
                font-weight: bold;
                margin-bottom: 1rem ;

                .icon{
                    width: 1.4rem;
                    color: #e2e6e7;
                    margin-right: 0.5rem;
                    vertical-align: bottom;
                }
            }
        }

        .contFoot{

            background: #efefef;
            padding: 0.5rem 2rem;

            @include mobile {
                .control{
                    margin-bottom: 0;
                }
            }



            .button{
                padding: 1.5rem 2rem;
                .icon {margin-right: 0.5rem; width: 1rem}
                &.is-text{
                    text-decoration: none;
                    color: #666;
                    &:hover{background: none}
                }
            }

        }

        // formulaires
        .control {

            margin: 0 1.5rem 0 0;
            @include mobile {
                margin-bottom: 1rem;
            }

            .label{
                font-size: 0.95rem; color: #444;
                &::first-letter{
                    // on force la majuscule sur la 1ère lettre des labels
                    text-transform: uppercase;
                }
            }
        }
        //$inputMargin : 0 1rem 0; // la marge des items de formulaire

        .input[type="text"],.input[type="email"],.input[type="password"]{
            background:white;
            padding: 1.5rem 1.5rem !important;
            color: #666;
            //margin: $inputMargin;

            &:focus{
                color: $brandBlue;
                border: solid 1px $brandBlue;
                box-shadow: 0 0 2px $brandBlue;
                transition: box-shadow 400ms;
            }
        }

        select{
            color: #666;
            //margin: $inputMargin;
            //font-size: 18px;
            //padding: 0.3rem 0;
            @include mobile {
                margin-bottom: 1rem;
            }

            option{
                //color: red;
            }


        }
    }
      //////////////////////////////////////
      // DARK UI ///////////////////////////
      &.darkMode {

        $sectionColor: $darkBg4;
        .formSection{
          background: $sectionColor !important;
          border-color: lighten($sectionColor,15%);

          .label{
            color: $darkTxt;
          }
          .help{
            color:#666;
            &.is-danger{color: $danger}
            &.is-warning{color: #f8b81f}
          }
          .contTitle {
            .icon {
              color: $darkLightBlue;
            }
            h3{
              color: $darkTxt;
            }

          }
        }
        .contFoot{
          background: darken($sectionColor,3%);
        }
        .input{

        }

      }
}

</style>
